import React from 'react';

import { retryImportChunk } from '@savgroup-front-common/core/helpers/retryImportChunk';

export const ClientVisioPage = React.lazy(() =>
  retryImportChunk(() => import('../../pages/ClientVisioPage/ClientVisioPage')),
);
